import { statusAuditTrail } from '@/store/params';
import { date } from '../../../../lib/helpers';
import { headers, search } from './attributes';

const processNameOptions = [
  'merchant_callback_notif',
  'snap_access_token',
  'merchant_callback_settlement'
];

export default {
  data: () => ({
    options: {},
    headers,
    search,
    filterValue: {
      trace_id: '',
      bill_number: '',
      merchant_id: '',
      rrn: '',
      process_name: '',
      status: '',
      request_date: [],  
    },
    filterType: [
      { key: 'trace_id', type: 'textfield', props: { label: 'Trace ID' } },
      { key: 'bill_number', type: 'textfield', props: { label: 'Bill Number' } },
      { key: 'merchant_id', type: 'textfield', props: { label: 'Merchant ID' } },
      { key: 'rrn', type: 'textfield', props: { label: 'Reff ID' } },
      { key: 'process_name', type: 'combobox', props: { label: 'Type', items: processNameOptions, hint: 'Select or type manually', persistentHint: true } },
      { key: 'status', type: 'select', props: { label: 'Status', items: statusAuditTrail } },
      { key: 'request_date', type: 'daterange', props: { label: 'Request Date & Time', includeToday: true, limitRangeTo30Days: true, defaultToday: true, withTime: true } },
    ],
  }),

  computed: {
    allData() {
      const data = this.$store.state.callbackApiLog.allData || [];
      return data.map(item => ({
        ...item,
        billNumber: item.request_raw?.additionalInfo?.billNumber 
                 || item.request_raw?.bill_number 
                 || '',
      }));
    },
    totalData() {
      return this.$store.state.callbackApiLog.totalData;
    },
    totalPage() {
      return this.$store.state.callbackApiLog.totalPage;
    },
    loading() {
      return this.$store.state.callbackApiLog.loading;
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
    },
  },
  methods: {

    baseFilterData(newSearch) {
      this.search.trace_id = newSearch.trace_id || '';
      this.search.bill_number = newSearch.bill_number || '';
      this.search.merchant_id = newSearch.merchant_id || '';
      this.search.rrn = newSearch.rrn || '';
      this.search.process_name = newSearch.process_name || '';
      this.search.status = newSearch.status || '';
      this.search.request_date = newSearch.request_date || [];
      this.options.page = 1;
      this.getData(); 
    },
    updateSearch(newSearch) {
      this.baseFilterData(newSearch);
    },
    showType(newSearch) {
      this.baseFilterData(newSearch);
    },
    getData() {
      const { page, itemsPerPage } = this.options;

      this.$store
        .dispatch('callbackApiLog/getData', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        });
    },
    copyToClipboard(content) {
      const text = typeof content === 'object' ? JSON.stringify(content, null, 2) : content;
      navigator.clipboard.writeText(text);
    },
    getRrn(item) {
      const requestRaw = item?.request_raw;
      return requestRaw?.rrn || requestRaw?.additionalInfo?.retrievalReferenceNumber || '';
    },
    clearSearch() {
      this.search.request_date = [];
      this.search.trace_id = '';
      this.search.process_name = '';
      this.search.bill_number = '';
      this.search.merchant_id = '';
      this.search.rrn = '';
      this.search.status = '';
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};